
export const approvalSelectData = [
    { value: '0', label: 'Select Approval' },
    { value: '1', label: 'Approved' },
    { value: '2', label: 'Reject' },
];

export const leaveDetailsColor = {
    "LOP": "error",
    "P!": "error",
    "-": "pink",
    "P": "blue",
    "P | wfh": "yellow",
    "HD": "green",
    "HD | wfh": "cyan",
    "WO": "geekblue",
    "CL": "gold",
    "SL": "lime",
    "UL": "green",
    "PL": "yellow",
    "P(late)": "pink",
    "P(late) | wfh": "yellow",
    "P | oth": "purple",
    "P(late) | oth": "purple",
    "HD | oth": "orange",
    "HD(late) | oth": "orange",
    "L": "error"
};

export const leaveDetailsAbbreviation = {
    "-": "Future",
    "LOP": "Loss of Pay",
    "P!": "Not Clocked Out",
    "P": "Present",
    "P | wfh": "Present | Work From Home",
    "HD": "Half Day",
    "HD | wfh": "Half Day | Work From home",
    "P(late)": "Present but Late",
    "P(late) | wfh": "Present but Late | Work From Home",
    "WO": "Week Off",
    "SL": "Sick leave",
    "CL": "Casual Leave",
    "UL": "Unpaid Leave",
    "PL": "Privilege Leave",
    "P | oth": "Present | Other Location",
    "P(late) | oth": "Present but Late | Other Location",
    "HD | oth": "Half Day | Other Location",
    "HD(late) | oth": "Half Day but Late | Other Location"
};

export const leaveDetailsAbbreviationOutsource = {
    "-": "Future",
    "LOP": "Loss of Pay",
    "P!": "Not Clocked Out",
    "P": "Present",
    "P | wfh": "Present | Work From Home",
    "HD": "Half Day",
    "HD | wfh": "Half Day | Work From home",
    "P(late)": "Present but Late",
    "P(late) | wfh": "Present but Late | Work From Home",
    "P | oth": "Present from Other Location",
    "L": "General Leave"
};

export function truncateString(str, num) {
    if (str.length > num) {
        return str.slice(0, num) + '...';
    } else {
        return str;
    }
}